import { render } from "./shoppingIndex.vue?vue&type=template&id=57cf095b&scoped=true"
import script from "./shoppingIndex.vue?vue&type=script&lang=js"
export * from "./shoppingIndex.vue?vue&type=script&lang=js"

import "./shoppingIndex.vue?vue&type=style&index=0&id=57cf095b&scoped=true&lang=scss"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cf095b"]])

export default __exports__